var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createLocalJWKSet } from 'jose';
import * as utilities from '../utilities/index.js';
import { getSDKHeader } from '../version.js';
import { getRemoteJwks } from '../utilities/remote-jwks-cache.js';
/**
 * Class provides implementation for the client credentials OAuth2.0 flow.
 * @class ClientCredentials
 */
var ClientCredentials = /** @class */ (function () {
    function ClientCredentials(config) {
        var _this = this;
        this.config = config;
        var authDomain = config.authDomain, logoutRedirectURL = config.logoutRedirectURL;
        this.logoutEndpoint = "".concat(authDomain, "/logout?redirect=").concat(logoutRedirectURL !== null && logoutRedirectURL !== void 0 ? logoutRedirectURL : '');
        this.tokenEndpoint = "".concat(authDomain, "/oauth2/token");
        this.config = config;
        var keyProvider = function () { return __awaiter(_this, void 0, void 0, function () {
            var func, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(config.jwks !== undefined)) return [3 /*break*/, 1];
                        _a = createLocalJWKSet(config.jwks);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, getRemoteJwks(authDomain)];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        func = _a;
                        return [4 /*yield*/, func({ alg: 'RS256' })];
                    case 4: return [2 /*return*/, _b.sent()];
                }
            });
        }); };
        this.tokenValidationDetails = {
            issuer: config.authDomain,
            audience: config.audience,
            keyProvider: keyProvider,
        };
    }
    /**
     * Method retrieves the access token, if the token present in the current session
     * is unexpired it will be returned otherwise, a new one will be be obtained by
     * performing a network call.
     * @param {SessionManager} sessionManager
     * @returns {Promise<string>}
     */
    ClientCredentials.prototype.getToken = function (sessionManager) {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, isTokenExpired, payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utilities.getAccessToken(sessionManager)];
                    case 1:
                        accessToken = _a.sent();
                        return [4 /*yield*/, utilities.isTokenExpired(accessToken, this.tokenValidationDetails)];
                    case 2:
                        isTokenExpired = _a.sent();
                        if (accessToken && !isTokenExpired) {
                            return [2 /*return*/, accessToken];
                        }
                        return [4 /*yield*/, this.fetchAccessTokenFor(sessionManager)];
                    case 3:
                        payload = _a.sent();
                        return [4 /*yield*/, utilities.commitTokenToSession(sessionManager, payload.access_token, 'access_token', this.tokenValidationDetails)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, payload.access_token];
                }
            });
        });
    };
    /**
     * Method implements logic for requesting access token using token endpoint.
     * @param {SessionManager} sessionManager
     * @returns {Promise<OAuth2CCTokenResponse>}
     */
    ClientCredentials.prototype.fetchAccessTokenFor = function (sessionManager) {
        return __awaiter(this, void 0, void 0, function () {
            var body, headers, config, response, payload, errorPayload, errorDescription, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = this.generateTokenURLParams();
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                        headers.append.apply(headers, __spreadArray([], __read(getSDKHeader({
                            frameworkVersion: this.config.frameworkVersion,
                            framework: this.config.framework,
                        })), false));
                        config = { method: 'POST', headers: headers, body: body };
                        return [4 /*yield*/, fetch(this.tokenEndpoint, config)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        payload = (_a.sent());
                        errorPayload = payload;
                        if (!errorPayload.error) return [3 /*break*/, 4];
                        return [4 /*yield*/, sessionManager.destroySession()];
                    case 3:
                        _a.sent();
                        errorDescription = errorPayload.error_description;
                        message = errorDescription !== null && errorDescription !== void 0 ? errorDescription : errorPayload.error;
                        throw new Error(message);
                    case 4: return [2 /*return*/, payload];
                }
            });
        });
    };
    /**
     * Method returns a boolean indicating if the access token in session is expired
     * or not, in the event the token is expired it makes use of the `getToken` method
     * above to first refresh it, in the event refresh fails false is returned.
     * @param sessionManager
     * @returns {Promise<boolean>}
     */
    ClientCredentials.prototype.isAuthenticated = function (sessionManager) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getToken(sessionManager)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Method provides the query params required for generating the token URL for
     * obtaining the required access token.
     * @returns {URLSearchParams}
     */
    ClientCredentials.prototype.generateTokenURLParams = function () {
        if (!utilities.validateClientSecret(this.config.clientSecret)) {
            throw new Error("Invalid client secret ".concat(this.config.clientSecret));
        }
        var searchParams = new URLSearchParams({
            grant_type: 'client_credentials',
            client_id: this.config.clientId,
            client_secret: this.config.clientSecret,
        });
        if (this.config.scope !== undefined) {
            searchParams.append('scope', this.config.scope);
        }
        if (this.config.audience) {
            var audienceArray = Array.isArray(this.config.audience)
                ? this.config.audience
                : [this.config.audience];
            audienceArray.forEach(function (aud) {
                searchParams.append('audience', aud);
            });
        }
        return new URLSearchParams(searchParams);
    };
    return ClientCredentials;
}());
export { ClientCredentials };
